"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FeatureFlag_1 = require("@CommonFrontendBackend/FeatureFlag");
var Sending = (function () {
    function Sending(createUi, acceptUtils, usingFeature, concentricSpinner, invoke) {
        var view;
        var isUsingInlineForm = !usingFeature(FeatureFlag_1.FeatureFlag.OptOutNewEditor);
        if (usingFeature(FeatureFlag_1.FeatureFlag.ViralAcceptFlow)) {
            view = require("./ViralSending.html");
        }
        else {
            view = require("./Sending.html");
        }
        this.ui = createUi(view, {
            showBranding: acceptUtils.showBranding,
            concentricSpinner: concentricSpinner,
            isUsingInlineForm: isUsingInlineForm,
        });
    }
    return Sending;
}());
exports.default = Sending;
